export function getFirstAvailableRoute({ appCore, profile }) {
    if (!appCore || !profile) return { name: 'threads' }

    const userChapters = profile.chapters || []
    const userIsMember = profile.is_member

    const items = appCore.appMenuNormalized.baseMenuItems || []

    const visible = items.filter((item) => {
        if (!item.title || !item.route) return false

        if (item.chapters?.length) {
            const hasChapter = item.chapters.some((chapter) =>
                userChapters.some((u) => u.chapter_id === chapter)
            )
            if (!hasChapter) return false
        }
        if (
            item.chapters.length === 0 &&
            item.exclude_chapters &&
            item.exclude_chapters.length
        ) {
            const hasExcludedChapter = userChapters.some(
                (userChapter) => item.exclude_chapters.includes(userChapter.chapter_id)
            )

            if (hasExcludedChapter) return false
        }

        if (item.role === null || item.block === 2) return true

        if ((item.role && userIsMember) || (!item.role && !userIsMember)) return true

        return false
    })

    if (!visible.length) return { name: 'threads' }

    const first = visible[0]

    return {
        name: first.route.name,
        ...(first.route.query ? { query: first.route.query } : {})
    }
}
